import React from 'react';
import { Table, LoadingSpinner } from 'edenred-ui';

import { DepositsTableProps } from '@epi-models/pages/Reports';

import { TableNoContent } from '../../TableNoContent';

import { DepositsTableHead } from './DepositsTableHead';
import { DepositsTableBody } from './DepositsTableBody';

export const DepositsTable = ({ deposits, isLoading }: DepositsTableProps) => {
  if (isLoading) return <LoadingSpinner />;
  return (
    <Table>
      <Table.Head>
        <DepositsTableHead />
      </Table.Head>
      <Table.Body>
        {deposits.length ? (
          <DepositsTableBody deposits={deposits} />
        ) : (
          <TableNoContent colSpan={6} />
        )}
      </Table.Body>
    </Table>
  );
};
